import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./performBetter.scss"

function PerformBetter() {
  const { t } = useTranslation()
  return (
    <div className='container-perform-better'>
      <div className="texts-perform-better">
        <SectionComponent title={t("health.perform_better.title")} text={t("health.perform_better.section_text_1")} >
          <p>{t("health.perform_better.section_text_2")}</p>
        </SectionComponent>
      </div>
    </div>
  )
}

export default PerformBetter